import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-dialog-xml-preview',
  imports: [MatDialogModule, MatIconModule, MatSnackBarModule],
  template: `
    <h1 mat-dialog-title>XML Vorschau</h1>
    <mat-dialog-content>
        <div style="position: relative;">
            <button mat-icon-button (click)="copyXml()"
                    style="position: sticky; top: 0; right: 0; z-index: 10; float: right;"
                    matTooltip="XML kopieren">
                <mat-icon>content_copy</mat-icon>
            </button>
            <pre style="background: var(--app-surface-variant); border-radius: 4px; font-family: 'Courier New', monospace; font-size: 12px; line-height: 1.5; padding: 16px; white-space: pre-wrap; word-wrap: break-word;" [innerHTML]="formattedXml"></pre>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeDialog()">Schließen</button>
    </mat-dialog-actions>
  `
})
export class XmlPreviewDialogComponent {
  public formattedXml: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { xml: string },
    public dialogRef: MatDialogRef<XmlPreviewDialogComponent>,
    private snackBar: MatSnackBar
  ) {
    // We get raw XML and escape it for safe display in <pre>
    // The copy function will use the raw, unescaped XML from this.data.xml
    this.formattedXml = this.data.xml.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  copyXml(): void {
    navigator.clipboard.writeText(this.data.xml).then(
      () => this.snackBar.open('XML in die Zwischenablage kopiert', 'OK', { duration: 2000 }),
      () => this.snackBar.open('Fehler beim Kopieren', 'OK', { duration: 2000 })
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
